import { render, staticRenderFns } from "./PlayerIcon.vue?vue&type=template&id=79de7ddf&scoped=true&"
import script from "./PlayerIcon.vue?vue&type=script&lang=js&"
export * from "./PlayerIcon.vue?vue&type=script&lang=js&"
import style0 from "./PlayerIcon.vue?vue&type=style&index=0&id=79de7ddf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79de7ddf",
  null
  
)

export default component.exports